import React from 'react'
import { graphql } from 'gatsby'
import { bpMaxMD, bpMaxSM } from '~lib/breakpoints'
import { css } from '@emotion/core'
import styled from '@emotion/styled'
import Layout from '../components/layout'
import Container from '../components/container'
import Link from '../components/link'
import SEO from '../components/seo'
import theme from '../../config/theme'
import Hero from '../components/big-hero'
import { uniq, includes, truncate } from 'lodash'

import StudioProjectEntry from '../components/studio/studio-project-entry'

export default function RemoteStudioPage(props) {
  return <RemoteStudio {...props} />
}

function RemoteStudio({ data: { studio } }) {
  return (
    <Layout
      hero={
        <Hero
          title="🚧 工具 / 项目"
          text="用代码堆砌世界的 Coder 来说，任何一个小想法都可能满怀激情的熬夜动手写出来，这里作为记录这些有趣的想法的自留地。"
          bigEmoji="🚧"
          noImage={true}
        />
      }
      headerColor={theme.colors.white}
    >
      <SEO />
      <Container noVerticalPadding>
        <div
          css={css`
              padding: 30px 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 20px;
            `}
        >
          <h4>🧪 更多小项目集合前往 👉</h4>
          <div>
            <Link target="_blank" css={css`white-space: nowrap;`} partiallyActive
              activeClassName="active" to="https://app.ubug.io/">
              Ubug's Apps ↗
            </Link>
          </div>
        </div>
        <div
          css={css`
            display: grid;
            grid-gap: 20px;
            grid-template-columns: repeat(auto-fill, minmax(301px, 1fr));
          `}
        >
          {studio.edges.map(({ node: studioProject }, index) => (
            <StudioProjectEntry
              index={index}
              key={studioProject.id}
              title={studioProject.frontmatter.title}
              description={truncate(studioProject.frontmatter.description, {
                length: 190,
              })}
              contentPadding={studioProject.frontmatter.contentPadding}
              titleColor={studioProject.frontmatter.titleColor}
              btnStyle={studioProject.frontmatter.btnStyle}
              date={studioProject.frontmatter.date}
              banner={studioProject.frontmatter.banner}
              url={
                studioProject.fields.slug
                  ? studioProject.fields.slug
                  : `/studio/${studioProject.frontmatter.slug}`
              }
              tech={studioProject.frontmatter.tech}
            />
          ))}
        </div>
      </Container>
    </Layout>
  )
}

export const remoteStudioQuery = graphql`
  query {
    studio: allMdx(
      filter: {
          fields: {status: {eq: "online"},isStudio: {eq: true}}
      }
      sort: {order: DESC, fields: [frontmatter___date]}
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date
            description
            tech
            slug
            titleColor
            btnStyle
            contentPadding
            banner {
              ...bannerImage720
            }
          }
          fields {
            slug
            isStudio
          }
        }
      }
      totalCount
    }
  }
`
